import { render, staticRenderFns } from "./productNew.vue?vue&type=template&id=5e486d1c&scoped=true"
import script from "./productNew.vue?vue&type=script&lang=js"
export * from "./productNew.vue?vue&type=script&lang=js"
import style0 from "./productNew.vue?vue&type=style&index=0&id=5e486d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e486d1c",
  null
  
)

export default component.exports